__webpack_require__.p = "/widget/_next/";